import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { IonPopover, IonDatetime, DatetimeCustomEvent } from '@ionic/angular';

import { UniqueIDService } from 'src/app/services/unique-id/unique-id.service';

@Component({
  selector: 'app-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss'],
})

export class DateTimePickerComponent {
  @Input() label: string;
  @Input() colSize: number = 12;
  @Input() datatimePresentation: string = 'date';
  @Input() dateTimePickerMax: string;
  @Input() dateTimePickerMin: string;
  @Input() dateTimeValue: string;
  @Input() dateTimeFormat: 'date' | 'datetimestamp' = 'date';

  @ViewChild(IonPopover, { static: false }) popOver!: IonPopover;
  @ViewChild(IonDatetime, { static: false }) datetime!: IonDatetime;

  @Output() onDatetimeChanged = new EventEmitter<DatetimeCustomEvent>(true);


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.adjustPopoverPosistion();
  }
  @HostListener('window:orientationchange', ['$event'])
  onRotate(event: Event) {
    this.adjustPopoverPosistion();
  }

  private isPopupOverOpen: boolean;
  private PresentedPopupOverElement: HTMLElement;
  popOverHostElementId: string;

  constructor(public uniqueIDProvider: UniqueIDService) {
    this.popOverHostElementId = this.uniqueIDProvider.uuidv4();
  }

  onPopoverDidPresentHandle($event: Event) {
    const target = $event.target as HTMLElement;
    this.PresentedPopupOverElement = target;
    this.isPopupOverOpen = true;
  }

  onPopoverDidDismissHandle($event) {
    this.isPopupOverOpen = false;
    this.PresentedPopupOverElement = null;
  }

  adjustPopoverPosistion() {
    if (this.isPopupOverOpen && this.PresentedPopupOverElement) {
      this.popOver.dismiss();
    }
  }

  handleDateTimeChanged(event: Event) {
    const onChangeEvent = event as DatetimeCustomEvent;

    // patching for datetime value is out of range of min, max, 
    // because datetime trigger this event even though the value is out of range
    // then datetime will triger this event again after it adjusts the value into the range 

    const min = this.datetime.min;
    const max = this.datetime.max;
    const datetimeValue = onChangeEvent.target.value as string;
    if (min && datetimeValue < min) {
      this.datetime.value = min;
      return;
    }
    else if (max && datetimeValue > max) {
      this.datetime.value = max;
      return;
    }

    this.onDatetimeChanged.emit(onChangeEvent);
    const datetimeElement = onChangeEvent.target;
    const datetimeClassAttrs = datetimeElement.getAttribute('class');
    const monthYearPickerMode = datetimeClassAttrs.indexOf('month-year-picker-open') > -1;
    // if ion-datetime is wheel selection mode, do not close when value changed 
    // TODO(old): do not close popover for other wheel selction modes when we support more date time mode
    const popOver = this.popOver;
    if (!monthYearPickerMode) {
      // this.datetime.confirm(); //caused date change looping - TODO(old): check and delete it
      popOver.dismiss();
    }
  }
}
